import { useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
export const useDeviceType = () => {
    const theme = useMantineTheme();
    // Determine if the device is a touch device
    const hasCoarsePointer = useMediaQuery("(pointer: coarse)");
    const hasTouch = typeof window !== "undefined" &&
        ("ontouchstart" in window || navigator.maxTouchPoints > 0);
    const isTouchDevice = hasCoarsePointer || hasTouch;
    // Determine the screen size
    const isUpToExtraSmallScreen = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);
    const isAtLeastExtraSmallScreen = useMediaQuery(`(min-width: ${theme.breakpoints.xs})`);
    const isUpToSmallScreen = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
    const isAtLeastSmallScreen = useMediaQuery(`(min-width: ${theme.breakpoints.sm})`);
    const isUpToMediumScreen = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);
    const isAtLeastMediumScreen = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);
    // Treat "large" as Mantine's xl breakpoint (largest named breakpoint)
    const isUpToLargeScreen = useMediaQuery(`(max-width: ${theme.breakpoints.xl})`);
    const isAtLeastLargeScreen = useMediaQuery(`(min-width: ${theme.breakpoints.xl})`);
    return {
        isTouchDevice,
        isUpToExtraSmallScreen,
        isAtLeastExtraSmallScreen,
        isUpToSmallScreen,
        isAtLeastSmallScreen,
        isUpToMediumScreen,
        isAtLeastMediumScreen,
        isUpToLargeScreen,
        isAtLeastLargeScreen
    };
};
